import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as actions from '../course-player.actions';
import * as fromCoursePlayer from '../course-player.reducer';

@Component({
  selector: 'app-player-overlay',
  templateUrl: './player-overlay.component.html'
})
export class PlayerOverlayComponent implements OnInit {

  constructor(private store: Store<{ coursePlayerState: fromCoursePlayer.State }>) { }

  ngOnInit(): void {
  }

  closeTips() {    
      this.store.dispatch(new actions.ShowTips());    
  }
}
